import { Box, Typography } from '@mui/material';

export const OutfitTitle = () => (
	<Box>
		<Typography
			component="h2"
			sx={{
				color: '#2A2A2A',
				fontWeight: 800,
				fontSize: { xs: '18px', md: '24px' },
				textTransform: 'uppercase',
			}}
		>
			{'Compra el look'}
		</Typography>
		<Typography
			sx={{
				color: '#2A2A2A',
				fontWeight: 500,
				fontSize: { xs: '14px', md: '15px' },
			}}
		>
			{'Selecciona la talla de tus productos favoritos'}
		</Typography>
	</Box>
);
